import AccountBalanceWalletRoundedIcon from '@mui/icons-material/AccountBalanceWalletRounded'
import ArrowBackRoundedIcon from '@mui/icons-material/ArrowBackRounded'
import CableRoundedIcon from '@mui/icons-material/CableRounded'
import CalendarMonthRoundedIcon from '@mui/icons-material/CalendarMonthRounded'
import CastConnectedRoundedIcon from '@mui/icons-material/CastConnectedRounded'
import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded'
import DockIcon from '@mui/icons-material/Dock'
import EventAvailableRoundedIcon from '@mui/icons-material/EventAvailableRounded'
import HighlightOffRoundedIcon from '@mui/icons-material/HighlightOffRounded'
import PodcastsIcon from '@mui/icons-material/Podcasts'
import ReportGmailerrorredIcon from '@mui/icons-material/ReportGmailerrorred'
import SignalCellularAltIcon from '@mui/icons-material/SignalCellularAlt'
import SimCardRoundedIcon from '@mui/icons-material/SimCardRounded'
import WifiRoundedIcon from '@mui/icons-material/WifiRounded'
import {
  Box,
  Button,
  Card,
  Container,
  Divider,
  IconButton,
  Tooltip,
  Typography,
} from '@mui/material'
import { Dispatch } from '@reduxjs/toolkit'
import _ from 'lodash'
import React, { useEffect } from 'react'
import persian from 'react-date-object/calendars/persian'
import persian_fa from 'react-date-object/locales/persian_fa'
import { useTranslation } from 'react-i18next'
import { DateObject } from 'react-multi-date-picker'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate, useParams } from 'react-router-dom'

import anten from '../../assests/icons/anten.png'
import anten00 from '../../assests/icons/anten00.png'
import anten01 from '../../assests/icons/anten01.png'
import anten02 from '../../assests/icons/anten02.png'
import anten03 from '../../assests/icons/anten03.png'
import gps from '../../assests/icons/gps.png'
import gps00 from '../../assests/icons/gps00.png'
import gps01 from '../../assests/icons/gps01.png'
import gps02 from '../../assests/icons/gps02.png'
import { getDeviceStatus, getStatusDevice } from '../../store/devices'
const StatusDeviceScreen = () => {
  const { id } = useParams()
  const dispatch = useDispatch<Dispatch<any>>()
  const { t } = useTranslation()
  const statusDevice = useSelector(getStatusDevice)
  const navigate = useNavigate()
  useEffect(() => {
    if (id !== undefined) {
      dispatch(getDeviceStatus(id))
    }
  }, [])
  const shamsi = (time: any) => {
    if (time === null) return
    const time1 = time
    const replaceTime = _.replace(time1, 'T', ' ')

    const date = new DateObject({
      date: replaceTime,
      format: 'YYYY/MM/DD HH:mm:ss',
    })
    date.convert(persian, persian_fa)
    date.add(3, 'hour')
    date.add(30, 'minute')
    return date.format('YYYY/MM/DD HH:mm:ss')
  }
  const getConnectInternet = () => {
    if (statusDevice.internetConnected === true) {
      return (
        <IconButton>
          <CheckCircleRoundedIcon sx={{ color: 'green' }} />
        </IconButton>
      )
    } else {
      return (
        <IconButton>
          <HighlightOffRoundedIcon sx={{ color: 'red' }} />
        </IconButton>
      )
    }
  }
  const getConnectCableObd = () => {
    if (statusDevice.obdConnected === true) {
      return (
        <IconButton>
          <CheckCircleRoundedIcon sx={{ color: 'green' }} />
        </IconButton>
      )
    } else if (statusDevice.obdConnected === true) {
      return (
        <Tooltip title='کابل متصل است ولی ارتباط اینترنت برقرار نمی باشد'>
          <IconButton>
            <ReportGmailerrorredIcon sx={{ color: 'orange' }} />
          </IconButton>
        </Tooltip>
      )
    } else {
      return (
        <IconButton>
          <HighlightOffRoundedIcon sx={{ color: 'red' }} />
        </IconButton>
      )
    }
  }
  const getdeviceConnected = () => {
    if (statusDevice.deviceConnected === true && statusDevice.internetConnected === true) {
      return (
        <IconButton>
          <CheckCircleRoundedIcon sx={{ color: 'green' }} />
        </IconButton>
      )
    } else if (statusDevice.deviceConnected === true) {
      return (
        <Tooltip title='کابل متصل است ولی ارتباط اینترنت برقرار نمی باشد'>
          <IconButton>
            <ReportGmailerrorredIcon sx={{ color: 'orange' }} />
          </IconButton>
        </Tooltip>
      )
    } else {
      return (
        <IconButton>
          <HighlightOffRoundedIcon sx={{ color: 'red' }} />
        </IconButton>
      )
    }
  }
  const getAnten = () => {
    if (statusDevice?.gsmAntena === 0) return <img src={anten00} width='20px' />
    if (statusDevice?.gsmAntena <= 10) return <img src={anten01} width='20px' />
    if (statusDevice?.gsmAntena <= 17) return <img src={anten02} width='20px' />
    if (statusDevice?.gsmAntena <= 25) return <img src={anten03} width='20px' />
    if (statusDevice?.gsmAntena <= 31) return <img src={anten} width='20px' />
  }
  const getGps = () => {
    if (statusDevice?.satelliteNo === 0) return <img src={gps00} width='23px' />
    if (statusDevice?.satelliteNo <= 3) return <img src={gps01} width='23px' />
    if (statusDevice?.satelliteNo <= 9) return <img src={gps02} width='23px' />
    if (statusDevice?.satelliteNo <= 12) return <img src={gps} width='23px' />
    if (statusDevice?.satelliteNo > 12) return <img src={gps} width='23px' />
  }

  return (
    <Container fixed maxWidth='sm'>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          maxHeight: '85vh',
          direction: 'ltr',
        }}
      >
        <Box display='grid' gridTemplateColumns='auto auto' sx={{ mt: 2, mb: 2, direction: 'ltr' }}>
          <ArrowBackRoundedIcon
            onClick={() => navigate(-1)}
            sx={{
              backgroundColor: 'red',
              borderRadius: '50%',
              color: '#fff',

              cursor: 'pointer',
            }}
          />
          <img alt='Logo' src='/images/TinyLogo.png' />
        </Box>
        <Box sx={{ mb: 2, ml: 1 }}>
          <Typography
            sx={{ color: 'grey.700', display: 'flex', justifyContent: 'center' }}
            variant='h5'
          >
            {t('screens.statusDevice.statusDevice_title_text')}
          </Typography>
        </Box>
        <Card
          sx={{
            color: 'grey.700',
            background: 'linear-gradient(rgb(247 252 252), #b0b0b0)',
            borderRadius: 1,
            p: 1,
            display: 'flex',
            justifyContent: 'space-between',
            marginBottom: 1,
            alignItems: 'center',
          }}
        >
          <Box display='flex'>
            <WifiRoundedIcon />
            <Typography>{t('screens.statusDevice.connectInternet_title_text')}</Typography>
          </Box>
          {getConnectInternet()}
          {/* {statusDevice.internetConnected === true ? (
            <CheckCircleRoundedIcon sx={{ color: 'green' }} />
          ) : (
            <HighlightOffRoundedIcon sx={{ color: 'red' }} />
          )} */}
        </Card>
        <Card
          sx={{
            color: 'grey.700',
            background: 'linear-gradient(rgb(247 252 252), #b0b0b0)',
            borderRadius: 1,
            p: 1,
            display: 'flex',
            justifyContent: 'space-between',
            marginBottom: 1,
            alignItems: 'center',
          }}
        >
          <Box display='flex'>
            <CableRoundedIcon />
            <Typography>{t('screens.statusDevice.connectCableObd_title_text')}</Typography>
          </Box>
          {getConnectCableObd()}
          {/* {statusDevice.obdConnected === true && statusDevice.internetConnected === true ? (
            <CheckCircleRoundedIcon sx={{ color: 'green' }} />
          ) : (
            <HighlightOffRoundedIcon sx={{ color: 'red' }} />
          )} */}
        </Card>

        <Card
          sx={{
            color: 'grey.700',
            background: 'linear-gradient(rgb(247 252 252), #b0b0b0)',
            borderRadius: 1,
            p: 1,
            display: 'flex',
            justifyContent: 'space-between',
            marginBottom: 1,
            alignItems: 'center',
          }}
        >
          <Box display='flex'>
            <CastConnectedRoundedIcon />
            <Typography>{t('screens.statusDevice.connectDevice_title_text')}</Typography>
          </Box>
          {getdeviceConnected()}
          {/* {statusDevice.deviceConnected === true && statusDevice.internetConnected === true ? (
            <CheckCircleRoundedIcon sx={{ color: 'green' }} />
          ) : (
            <HighlightOffRoundedIcon sx={{ color: 'red' }} />
          )} */}
        </Card>
        <Divider sx={{ m: 1 }} variant='middle' />
        <Card
          sx={{
            color: 'grey.700',
            background: 'linear-gradient(rgb(247 252 252), #b0b0b0)',
            borderRadius: 1,
            p: '5px',
            display: 'flex',
            justifyContent: 'space-between',
            marginBottom: 1,
            alignItems: 'center',
          }}
        >
          <Box display='flex'>
            <AccountBalanceWalletRoundedIcon />
            <Typography>{t('screens.statusDevice.balanceSimNumber_title_text')}</Typography>
          </Box>

          <Typography>{statusDevice.simBalance} ريال</Typography>
        </Card>
        <Card
          sx={{
            color: 'grey.700',
            background: 'linear-gradient(rgb(247 252 252), #b0b0b0)',
            borderRadius: 1,
            p: '5px',
            display: 'flex',
            justifyContent: 'space-between',
            marginBottom: 1,
            alignItems: 'center',
          }}
        >
          <Box display='flex'>
            <DockIcon />
            <Typography>{t('screens.statusDevice.imei_title_text')}</Typography>
          </Box>

          <Typography>{statusDevice.deviceId}</Typography>
        </Card>
        <Card
          sx={{
            color: 'grey.700',
            background: 'linear-gradient(rgb(247 252 252), #b0b0b0)',
            borderRadius: 1,
            p: '5px',
            display: 'flex',
            justifyContent: 'space-between',
            marginBottom: 1,
            alignItems: 'center',
          }}
        >
          <Box display='flex'>
            <SimCardRoundedIcon />
            <Typography>{t('screens.statusDevice.simNumber_title_text')}</Typography>
          </Box>
          <Typography>{statusDevice.simNo}</Typography>
        </Card>

        <Card
          sx={{
            color: 'grey.700',
            background: 'linear-gradient(rgb(247 252 252), #b0b0b0)',
            borderRadius: 1,
            p: '5px',
            display: 'flex',
            justifyContent: 'space-between',
            marginBottom: 1,
            alignItems: 'center',
          }}
        >
          <Box display='flex'>
            <CalendarMonthRoundedIcon />
            <Typography>{t('screens.statusDevice.registeredTime_title_text')}</Typography>
          </Box>
          <Typography>{shamsi(statusDevice.registeredTime)}</Typography>
        </Card>
        <Card
          sx={{
            color: 'grey.700',
            background: 'linear-gradient(rgb(247 252 252), #b0b0b0)',
            borderRadius: 1,
            p: '5px',
            display: 'flex',
            justifyContent: 'space-between',
            marginBottom: 1,
            alignItems: 'center',
          }}
        >
          <Box display='flex'>
            <EventAvailableRoundedIcon />
            <Typography>{t('screens.statusDevice.overServiceTime_title_text')}</Typography>
          </Box>
          <Typography>{shamsi(statusDevice.overServiceTime)}</Typography>
        </Card>
        <Card
          sx={{
            color: 'grey.700',
            background: 'linear-gradient(rgb(247 252 252), #b0b0b0)',
            borderRadius: 1,
            p: '5px',
            display: 'flex',
            justifyContent: 'space-between',
            marginBottom: 1,
            alignItems: 'center',
          }}
        >
          <Box display='flex'>
            <EventAvailableRoundedIcon />
            <Typography>{t('screens.statusDevice.gpsStatus_title_text')}</Typography>
          </Box>
          <IconButton>{getGps()}</IconButton>
        </Card>
        <Card
          sx={{
            color: 'grey.700',
            background: 'linear-gradient(rgb(247 252 252), #b0b0b0)',
            borderRadius: 1,
            p: '5px',
            display: 'flex',
            justifyContent: 'space-between',
            marginBottom: 1,
            alignItems: 'center',
          }}
        >
          <Box display='flex'>
            <EventAvailableRoundedIcon />
            <Typography>{t('screens.statusDevice.antenDeviceStatus_title_text')}</Typography>
          </Box>
          <IconButton>{getAnten()}</IconButton>
        </Card>
        <Card
          sx={{
            color: 'grey.700',
            background: 'linear-gradient(rgb(247 252 252), #b0b0b0)',
            borderRadius: 1,
            p: '5px',
            display: 'flex',
            justifyContent: 'space-between',
            marginBottom: 1,
            alignItems: 'center',
          }}
        >
          <Box display='flex'>
            <EventAvailableRoundedIcon />
            <Typography>{t('screens.statusDevice.vin_title_text')}</Typography>
          </Box>
          <IconButton>{statusDevice.vin}</IconButton>
        </Card>
        <Card
          sx={{
            color: 'grey.700',
            background: 'linear-gradient(rgb(247 252 252), #b0b0b0)',
            borderRadius: 1,
            p: '5px',
            display: 'flex',
            justifyContent: 'space-between',
            marginBottom: 1,
            alignItems: 'center',
          }}
        >
          <Box display='flex'>
            <EventAvailableRoundedIcon />
            <Typography>{t('screens.statusDevice.softwareVersion_title_text')}</Typography>
          </Box>
          <IconButton>{statusDevice.softwareVersion}</IconButton>
        </Card>
      </Box>
    </Container>
  )
}

export default StatusDeviceScreen
